import { ChangeDetectorRef, Component ,EventEmitter, Output} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { find, get } from 'lodash';

// store
import { AppState } from '../app-reducer';
import { Store } from '@ngrx/store';
import { debounceTime, distinctUntilChanged, first } from 'rxjs/operators';

// pop up
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { animate, style, transition, trigger } from '@angular/animations';

import { ComposableService } from '../services/composable.service';
import {ModalComponent} from '../../../../../src/app/components/modal.component';
import { AppConstants } from '../app.constants';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'demo-subnav-component',
  templateUrl: './demo-subnav.component.html',
  styleUrls: [],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('1s ease-out', style({ height: 300, opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: 300, opacity: 1 }),
        animate('1s ease-in', style({ height: 0, opacity: 0 }))
      ])
    ])
  ]
})
export class DemoSubnavComponent {
  appState$: Observable<any>;
  suppress: boolean = false;
  customerSigned: boolean = false;
  userRole: string;
  unlocked: boolean = false;
  showMe: boolean = false;
  isDemo: boolean = false;
  sectionMenuData: any;
  isError = false;
  disclosuresBlock = 35;
  preAuthInsuredBlock = 34;
  personalInfoBlock = 20;
  juvenileInsBlock = 19;
  declarationsAgentBlock = 39;
  AppId;
  ProposedInsuredEmailAddress;
  ProposedInsuredName;
  showModal = false;
  demoPortal = false;
  transmittalBlock: 38;
  agentReportBlock: 37;
  declarationsInsuredBlock: 36;

  constructor(
    private router: Router,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private composableService: ComposableService,
    private appConstants: AppConstants,
    private commonService: CommonService,
    private cdr: ChangeDetectorRef
  ) {
    this.appState$ = store.select('sections');
    const currentRoute = find(this.router.config, { path: location.pathname.substring(1) });
    this.appState$.pipe(
      first()
    ).subscribe((state: any) => {
      this.userRole = state.userRole.name;
      this.showMe = this.isError === false && (!this.userRole.includes('Insured') && currentRoute.data ? true : false);
    });
    router.events.pipe(debounceTime(100), distinctUntilChanged()).subscribe((val) => {
   this.appState$.pipe(
        first()
      ).subscribe((state: any) => {
        this.userRole = state.userRole.name;
        this.unlocked = state.unlocked;
        //this.customerSigned = this.validateFinalSignature(get(state, 'content.DeclarationsInsured.FinalSignature')) ? true:false;
        this.customerSigned = state.content.DeclarationsInsured ? state.content.DeclarationsInsured.FinalSignature ? state.content.DeclarationsInsured.FinalSignature.trim() : false : false;
        this.isDemo = state.isDemo;
        this.demoPortal = false;
        if ((currentRoute.path).includes('demo-welcome')){
          this.isDemo = true;
          this.demoPortal = true;
        }else if ((currentRoute.path).includes('financial-professional')){
          this.isDemo = false;
        }
        this.cdr.markForCheck();
        // Email Info
        this.AppId = state['content']['ApplicationId'] ? state['content']['ApplicationId'] : state['appId'];
          if (state['content'] && state['content']['SECTIONAProposedInsured']) {
            this.ProposedInsuredEmailAddress = state['content']['SECTIONAProposedInsured']['EmailAddress'];
            const firstName = state['content']['SECTIONAProposedInsured']['Name']['FirstName'];
            const lastName = state['content']['SECTIONAProposedInsured']['Name']['LastName'];
            this.ProposedInsuredName = (firstName && lastName) ? firstName + ' ' + lastName : null;
          }

          if (this.sectionMenuData) {
            this.disclosuresBlock = state.content.menuData.findIndex(x => x.name == 'Disclosures');
            this.preAuthInsuredBlock = state.content.menuData.findIndex(x => x.name == 'RequestforPreAuthorizedPaymentPlanInsured');
            this.personalInfoBlock = state.content.menuData.findIndex(x => x.name == 'SECTIONGPersonalInformation');
            this.juvenileInsBlock = state.content.menuData.findIndex(x => x.name == 'SECTIONIJuvenileInsurance');
            this.declarationsAgentBlock = state.content.menuData.findIndex(x => x.name == 'DeclarationsAgent');
            this.transmittalBlock = state.content.menuData.findIndex(x => x.name == 'TransmittalBlock');
            this.agentReportBlock = state.content.menuData.findIndex(x => x.name == 'AgentReport');
            this.declarationsInsuredBlock = state.content.menuData.findIndex(x => x.name == 'DeclarationsInsured');


          }
      });
      if (this.isDemo){
        if (this.userRole.includes('Insured')) {
          this.suppress = true;
        } else if (!this.userRole.includes('Insured') && this.customerSigned && [this.declarationsInsuredBlock, this.agentReportBlock, this.transmittalBlock, this.declarationsAgentBlock].includes(this.router.config.indexOf(currentRoute))) {
          this.suppress = true;
        } else if (!this.userRole.includes('Insured') && this.unlocked && this.router.config.indexOf(currentRoute) === this.declarationsInsuredBlock) {
          this.suppress = false;
        } else if (this.router.config.indexOf(currentRoute) <= this.personalInfoBlock || this.router.config.indexOf(currentRoute) >= this.declarationsAgentBlock) {
          this.suppress = true;
        } else {
          this.suppress = false;
        }
      }  else{
        this.suppress = false;
      }
      
      this.showMe = !this.userRole.includes('Insured') && currentRoute.data ? true : false;
    
    });
  }
  validateFinalSignature(signature:any) : boolean{
    if (signature === null || signature === undefined || signature === '' || (signature ? signature.trim().length === 0 : true)) {
      return false;
    }
    else {
      return true;
    }
  }

  backToMiniPortal() {
    // erase app memory to prevent old case data from displaying in agent's next case
    this.composableService.resetApplication();
    // go back to mini-portal or debug page
    this.appState$.pipe(first()).subscribe((state: any) => {
      state.isDemo = false;
      this.isDemo=false;
      this.commonService.logAppState(state);
    });
    const destination = this.userRole === 'Agent' ? 'express/financial-professional' : 'express';
    this.router.navigateByUrl(destination);
  }

  restartDemo() {
    // erase app memory to prevent old case data from displaying in agent's next case
    this.composableService.resetApplication();
    // go back to mini-portal or debug page
    this.appState$.pipe(first()).subscribe((state: any) => {
      state.isDemo = true;
      this.isDemo=true;
      this.commonService.logAppState(state);
    });
    this.demoPortal = true;
    this.router.navigateByUrl('express/demo-welcome');
  }

  suppressButtonSendToProposedInsured(currentRoute: any, unlocked: boolean): boolean {
    if (unlocked)
    {//come back and remove hardcoding of routes!!
      return (this.userRole.includes('Insured') || this.router.config.indexOf(currentRoute) < 37 || this.router.config.indexOf(currentRoute) > 38);//until disclosure block
    }
    else {
      return (this.userRole.includes('Insured') || this.router.config.indexOf(currentRoute) < 21 || this.router.config.indexOf(currentRoute) > 38)
    }
  }

    // Test
    triggerModal() {
      const dialogRef = this.dialog.open(ModalComponent, {
        disableClose:  true,
        closeOnNavigation: true,
        data: {
          AppId: this.AppId,
          ProposedInsuredEmailAddress: this.ProposedInsuredEmailAddress,
          ProposedInsuredName: this.ProposedInsuredName,
          size: '',
          // Array of screens
          emailInitError: (!(this.AppId && this.ProposedInsuredName && this.ProposedInsuredEmailAddress)),
          screens: [
            {
              show: true,
              exit_btn: true,
              content: [
                {
                  type: 'title',
                  content: 'Send application',
                  class: this.appConstants.modalTitleBold
                },
                {
                  type: 'text',
                  content: 'To share this application with ' + this.ProposedInsuredName + ', click "Send" below.',
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'text',
                  content: 'The email will be sent to ' + this.ProposedInsuredEmailAddress + '.',
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'text',
                  content: 'Once ' + this.ProposedInsuredName + ' accesses the e-application, they will be able to:',
                  class: this.appConstants.modalLiDefault
                },
                {
                  type: 'unordered_list',
                  unordered_list: [
                    {
                      type: 'unordered_list_item',
                      content: 'Review completed sections',
                      class: this.appConstants.modalLiDefault
                    },
                    {
                      type: 'unordered_list_item',
                      content: 'Complete any outstanding medical and/or lifestyle questions, and',
                      class: this.appConstants.modalLiDefault
                    },
                    {
                      type: 'unordered_list_item',
                      content: 'Electronically sign the e-application',
                      class: this.appConstants.modalLiDefault
                    },
                  ]
                },
                {
                  type: 'button_group',
                  buttons: [
                    {
                      type: 'button',
                      label: 'Cancel',
                      clickFunction: 'close',
                      class: this.appConstants.buttonSecondary
                    },
                    {
                      type: 'button',
                      label: 'Send',
                      clickFunction: 'sendEmail',
                      class: this.appConstants.buttonPrimary
                    }
                  ]
                },
              ]
            },
            // Success Screen
            {
              show: false,
              exit_btn: false,
              content: [
                {
                  type: 'title',
                  content: 'Success!',
                  class: this.appConstants.modalTitleBold
                },
                {
                  type: 'text',
                  content: 'We have sent the application to ' + this.ProposedInsuredName + ' at ' + this.ProposedInsuredEmailAddress + '.',
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'text',
                  content: 'Once ' + this.ProposedInsuredName + '  has signed the application, you will receive an email notification with next steps.',
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'text',
                  content: 'You can also track the status of the ' + this.ProposedInsuredName + ' signature in the JH eApp portal.',
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'button',
                  label: this.appConstants.eAppPortalLabel,
                  clickFunction: 'goToAgentPortal',
                  class: this.appConstants.buttonPrimary
                }
              ]
            },
            // Failure Screen
            {
              show: false,
              exit_btn: false,
              error_flag: true,
              content: [
                {
                  type: 'title',
                  content: this.appConstants.somethingWentWrong,
                  class: this.appConstants.modalTitleBold
                },
                {
                  type: 'text',
                  content: this.appConstants.technicalError,
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'button_group',
                  buttons: [
                    {
                      type: 'button',
                      label: 'Try Again',
                      clickFunction: 'sendEmail',
                      class: this.appConstants.buttonSecondary
                    }
                  ]
                }
              ]
            },
            // Fail on retry screen
            {
              show: false,
              exit_btn: false,
              content: [
                {
                  type: 'title',
                  content: this.appConstants.technicalIssueTitle,
                  class: this.appConstants.modalTitleBold
                },
                {
                  type: 'text',
                  content: this.appConstants.technicalFailureMessage,
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'text',
                  content: this.appConstants.inconvenienceMessage,
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'button_group',
                  buttons: [
                    {
                      type: 'button',
                      label: this.appConstants.eAppPortalLabel,
                      clickFunction: 'goToAgentPortal',
                      class: this.appConstants.buttonPrimary
                    }
                  ]
                }
              ]
            },
            {
              show: false,
              exit_btn: false,
              content: [
                {
                  type: 'title',
                  content: "Thank you for completing your portion of the application.",
                  class: this.appConstants.modalTitleBold
                },
                {
                  type: 'text',
                  content: 'In the next 2-3 minutes, ' + this.ProposedInsuredName + ' should receive an email at ' + this.ProposedInsuredEmailAddress + ' that includes a link to their sections of the application.',
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'text',
                  content: 'Once ' + this.ProposedInsuredName + ' has electronically signed the application, you will receive an email notification with next steps.',
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'text',
                  content: 'You can also track the status of the ' + this.ProposedInsuredName + "'s signature in the JH eApp portal.",
                  class: this.appConstants.modalParagraphDefault
                },
                {
                  type: 'button_group',
                  buttons: [
                    {
                      type: 'button',
                      label: this.appConstants.eAppPortalLabel,
                      clickFunction: 'goToAgentPortal',
                      class: this.appConstants.buttonPrimary
                    }
                  ]
                }
              ]
            }
          ]
        }
      });
    }
}
